const axios = require('axios');
const { baseUrlNew, buildAuthHeaders } = require('./settings.js');

exports.getDetails = function () {
  return axios.get(baseUrlNew + `shopify-integration`, {
    headers: buildAuthHeaders()
  });
};
